var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"client"}},[_c('div',[_c('Header')],1),_vm._v(" "),_c('div',[_c('Nav')],1),_vm._v(" "),_c('main',{staticClass:"main"},[_c('div',{staticClass:"container clearfloat"},[_c('router-view'),_vm._v(" "),_c('router-view',{attrs:{"name":"aside"}})],1)]),_vm._v(" "),_c('div',[_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c9d77bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/Client/index.vue
// module id = null
// module chunks = 